<div *ngIf="!linkedMetrics.length">{{ "krs_will_also_be_deleted" | localize }} {{ "this_cant_be_undone" | localize }}</div>

<ng-container *ngIf="linkedMetrics.length">
  <p>{{ "deleting_goal_breaks_kr_links" | localize }} {{ "krs_will_also_be_deleted" | localize }} {{ "this_cant_be_undone" | localize }}</p>
  <p>{{ "key_results_affected" | localize }}</p>
  <ul>
    <li *ngFor="let metric of linkedMetrics">
      <item-name-with-icon [name]="metric.name" icon="metric"></item-name-with-icon>
    </li>
  </ul>
</ng-container>
